import React from 'react';
import PropTypes from 'prop-types';
import scrollIntoView from 'scroll-into-view';
import windowCheck from '../../../global/windowCheck.es.js';
import {
    trackSimilarItemsDisplayed,
    trackSimilarItemClick,
    trackSimilarViewAllClick,
    trackProductClick,
} from '../../actions/pdpTrackingActions';

// Components
import SimilarHeader from './SimilarHeader';
import SimilarHeaderSold from './SimilarHeaderSold';
import SimilarItems from './SimilarItems';

class Similar extends React.Component {
    constructor(props) {
        super(props);

        this._handleClick = this._handleClick.bind(this);
        this._onSimilarCtaClick = this._onSimilarCtaClick.bind(this);
    }

    componentDidMount() {
        this.context.executeAction(trackSimilarItemsDisplayed);
    }

    _handleClick(item) {
        const name = this.props.itemIsUnavailable ? 'sold pdp' : 'pdp';

        this.context.executeAction(trackSimilarItemClick);
        this.context.executeAction(trackProductClick, {
            product: item,
            listName: `${name} browse similar items`,
        });
    }

    _onSimilarCtaClick(event) {
        const gridHeader = windowCheck.document.querySelector('.pdp-suggestion-grid-header');

        event.preventDefault();
        this.context.executeAction(trackSimilarViewAllClick);
        scrollIntoView(gridHeader, { time: 1000, align: { top: 0.1 } });
    }

    render() {
        const { copy, title, items, itemIsUnavailable } = this.props;

        return (
            <div className="pdp-similar primary-viewport-width">
                <div className="primary-page-width">
                    {itemIsUnavailable && <SimilarHeaderSold copy={copy.similar} title={title} />}
                    <div className="pdp-similar-header">
                        <SimilarHeader
                            copy={copy.similar}
                            title={title}
                            itemIsUnavailable={itemIsUnavailable}
                        />
                        <a href="#0" className="pdp-similar-cta" onClick={this._onSimilarCtaClick}>
                            {copy.similar.cta}
                        </a>
                    </div>
                    <SimilarItems
                        items={items}
                        onClick={this._handleClick}
                        itemIsUnavailable={itemIsUnavailable}
                    />
                </div>
            </div>
        );
    }
}

Similar.contextTypes = {
    executeAction: PropTypes.func.isRequired,
};

Similar.propTypes = {
    items: PropTypes.array,
    itemIsUnavailable: PropTypes.bool,
    copy: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
};

Similar.defaultProps = {
    items: [],
};

module.exports = Similar;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Similar/Similar.jsx